import { render } from "./PopupСallback.vue?vue&type=template&id=780ed7ae"
import script from "./PopupСallback.vue?vue&type=script&lang=js"
export * from "./PopupСallback.vue?vue&type=script&lang=js"

import "./PopupСallback.vue?vue&type=style&index=0&id=780ed7ae&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__